!((document, Drupal, $) => {
  'use strict';
  /**
   * Toggle mobile menu open and closed
   */

  Drupal.behaviors.headerToggle = {

    attach: function (context) {
      const $mobileMenuOpen = $('.js-mobile-menu-open', context);
      const $mobileMenuClose = $('.js-mobile-menu-close', context);
      const $mobileMenu = $('.js-mobile-menu', context);
      const $shopButton = $('.js-shop-button', context);
      const $stickyButton = $('.js-header-sticky', context);

      // On mobile menu button click...
      $mobileMenuOpen.on('click', (e) => {
        // Prevent the default click.
        e.preventDefault();
        // Add the shown button to the menu.
        $mobileMenu.addClass('is-shown');
      });

      // On close mobile menu button click...
      $mobileMenuClose.on('click', () => {
        // Close the menu.
        $mobileMenu.removeClass('is-shown');
      });

      // On shop menu button click...
      $shopButton.on('click', function(e) {
        // Prevent the default click.
        e.preventDefault();
        // Show the shop form dropdown.
        $(this).toggleClass('is-active');
      });

      // On button click, demo the sticky menu functionality.
      $stickyButton.on('click', () => {
        // Call Bootstrap's affix.
        $('.js-header').affix();
      });
    }
  };
})(document, Drupal, jQuery);
